export const LOCALES = {
  ENGLISH: 'en-us',
  FRENCH: 'fr-ca',
  ARABE: 'ar-ar',
  DEUTCH:'de-de'
};
